<template>
  <div class="app-container">
    <el-card class="box-card">
      <folded-panel infoName="基本信息">
        <div slot="content">
          <dynamic-form
            labelWidth="110px"
            :formConfig="formConfig"
            v-model="form"
            :disabled="!isEdit"
            :showBtn="false"
            ref="form"
          />
        </div>
      </folded-panel>
      <div class="button">
        <el-button
          class="btn-cancel"
          v-if="isEdit"
          :loading="loading"
          @click="save(1)"
          >保存</el-button
        >
        <el-button
          class="btn-submit"
          v-if="isEdit"
          :loading="loading"
          @click="submit(2)"
          >提交</el-button
        >
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
      <drag-dialog
        :show="stepShow"
        :title="'审批人选择'"
        :width="'25%'"
        @close="close"
      >
        <PersonStep
          :data="personStepData"
          @submit="submitConfirm"
          @close="close"
        ></PersonStep>
      </drag-dialog>
    </el-card>
  </div>
</template>

<script>
import FoldedPanel from "@/components/FoldedPanel";
import "@/components/dynamic-form";
import "@/components/EditDataTable";
import { parseTime } from "@/utils";
import initDict from "@/mixin/initDict";
import { tableSataus } from "@/views/bill/mixins/status";
import CrudMixin from "@/mixins/CrudMixin";
import { addRisk, getRisk, } from "@/api/bill/risk";
import { getDocumentCode } from "@/views/utils";
import { planNodeList } from "@/api/bill/ProjectPlan";
import DragDialog from "@/components/DragDialog"
import { getFlowNode } from "@/api/hrApproval"
import PersonStep from "@/components/PersonStep";
export default {
  name: "RiskForm",
  components: {
    FoldedPanel, DragDialog, PersonStep
  },
  mixins: [initDict, tableSataus, CrudMixin],
  data () {
    return {
      daoru: false,
      isEdit: true,
      loading: false,
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            label: "单据编号",
            value: "",
            placeholder: "请输入标题",
            span: 8,
            disabled: true
          },
          {
            type: "databox",
            key: "bsProject",
            label: "项目号",
            placeholder: "请选择项目",
            value: "",
            span: 8,
            props: {
              label: "projectNumber",
              value: "id"
            },
            url: "/projectDelivery",
            tableColumn: [
              {
                property: "projectNumber",
                label: "项目号"
              },
              {
                property: "projectName",
                label: "名称",
                query: {
                  type: "input"
                }
              },
              {
                property: "personManager",
                label: "项目负责人",
                formatter: cur => {
                  return cur ? cur.name : ''
                }
              }
            ],
            extendParms: { billState: 3, searchType: 4 },
            multiple: false,
            rules: [
              {
                required: true,
                message: "不能为空",
                trigger: "change"
              }
            ]
          },
          {
            type: "databox",
            key: "bsProjectNode",
            label: "项目节点",
            placeholder: "请选择项目节点",
            value: "",
            span: 8,
            props: {
              label: "milestoneName",
              value: "id"
            },
            // url: "projectDelivery/listProjectMilestone",
            tableColumn: [
              {
                property: "bsMilestoneNode",
                label: "编码",
                formatter: cur => { return cur.code }
              },
              {
                property: "milestoneName",
                label: "名称",
                query: {
                  type: "input"
                },
              },
            ],
            tableData: [],
            // extendParms: { id: this.milestoneNode},
            multiple: false,
            rules: [
              {
                required: true,
                message: "不能为空",
                trigger: "change"
              }
            ]
          },
          {
            type: "input",
            key: "appliedAmount",
            label: "申请金额",
            value: "",
            placeholder: "请输入申请金额",
            span: 8,
            rules: [
              {
                required: true,
                message: "不能为空",
                trigger: "blur"
              }
            ]
          },
          {
            type: "select",
            label: "风险层级",
            key: "riskGrade",
            span: 8,
            options: [],
            rules: [
              {
                required: true,
                message: "不能为空",
                trigger: "change"
              }
            ],
            disabled: true
          },
          {
            type: "textarea",
            key: "remark",
            label: "申请原因",
            value: "",
            placeholder: "请输入申请原因",
            span: 24,
            rules: [
              {
                required: true,
                message: "不能为空",
                trigger: "blur"
              }
            ]
          },
        ]
      },
      form: {},
      validateRefNames: ["form"],
      riskLevel: [],
      projectNumber: '',
      level: '',
      personStepData: [],
      assignData: {}, // hr审批人员信息
      stepShow: false,
    };
  },
  watch: {
    'form.bsProject': {
      handler (val, oldVal) {
        if (val && val !== oldVal) {
          this.projectNumber = val.projectNumber
          this.level = val.riskFundTotal
          planNodeList({ id: val.id }).then(res => {
            this.formConfig.formItemList[this.formConfig.formItemList.findIndex(i => i.key === 'bsProjectNode')].tableData = res.data;
          })
        }
      },
      deep: true
    },
    'form.appliedAmount': {
      handler (val, oldVal) {
        if (val) {
          const precent = parseInt(val) / parseInt(this.level)
          if (precent <= 0.2) {
            this.form.riskGrade = '1'
          } else if (precent <= 0.8) {
            this.form.riskGrade = '2'
          } else {
            this.form.riskGrade = '3'
          }
        }
      }
    }
  },
  created () {
    this.id = this.$route.params.id;
    this.isEdit = this.$route.params.isEdit !== undefined ? Boolean(Number(this.$route.params.isEdit)) : true;
    if (this.id) {
      getRisk(this.id).then(res => {
        const form = res.data;
        if (form.delivery) {
          this.projectNumber = form.delivery.projectNumber
          form.bsProject = { projectNumber: form.delivery.projectNumber, id: form.delivery.id, riskFundTotal: form.delivery.riskFundTotal }
        }
        if (form.milestonePlan) {
          form.bsProjectNode = { milestoneName: form.milestonePlan.bsMilestoneNode.name, code: form.milestonePlan.bsMilestoneNode.code, id: form.milestonePlan.id }
        }
        form.riskGrade = form.riskGrade.toString()
        this.form = form
        this.level = form.delivery.riskFundTotal
      });
    } else {
      this.form.code = getDocumentCode("SQFXJ");
    }
    this.getDict("riskLevel").then(res => {
      this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(i => i.key === "riskGrade")], "options", res.data);
      this.riskLevel = res.data;
    });
  },
  methods: {
    formatter (val) {
      if (val) {
        const date = new Date(val);
        return parseTime(date, "{y}-{m}-{d}");
      }
    },
    cancel () {
      this.$store.dispatch('tagsView/delView', this.$route)
      this.$router.go(-1);
    },
    // 保存
    save () {
      this.loading = true;
      this.update(this.getFormData());
    },
    close () {
      this.stepShow = false;
    },
    submitConfirm (val) {
      this.loading = true
      const obj = this.getFormData(2)
      const obj2 = {}
      val.forEach(item => {
        let userList = "";
        item.assignData.forEach(ite => {
          userList = userList + (userList === "" ? ite.id : "," + ite.id);
        });
        obj2[item.key] = userList;
      });
      obj.assignData = JSON.stringify(obj2)
      obj.from = "risk"
      this.update(obj)
    },
    // 提交
    submit () {
      this.loading = true;
      this._validateForm(this.validateRefNames).then(res => {
        const params = {
          from: "risk",
          id: this.form.id,
          projectCode: this.form.projectCode,
          appliedAmount: this.form.appliedAmount
        }
        if (!params.projectCode && this.form.bsProject) {
          params.projectCode = this.form.bsProject.projectNumber
        }
        getFlowNode(params).then(res => {
          this.loading = false;
          this.personStepData = [];
          if (res.code === 200) {
            this.stepShow = true;
            this.personStepData = res.data;
          }
        }).catch(e => {
          this.loading = false;
        });
      }).catch(e => {
        this.loading = false;
      });
    },
    update (data) {
      addRisk(data).then(res => {
        this.loading = false;
        if (res.code === 200) {
          this.$notify({
            title: "操作成功",
            type: "success",
            duration: 2500
          });
          if (data.billState === 1) {
            if (this.form.id) {
              // 保存
              const { path } = this.$route
              this.$store.dispatch('tagsView/delCachedView', this.$route).then(() => {
                this.$router.replace({
                  path: '/redirect' + path
                })
              })
            } else {
              const {path} = this.$route
              this.$store.dispatch('tagsView/delView', this.$route).then(() => {
                this.$router.replace({path: '/redirect' + `${path}/1/${res.data}`})
              })
            }
          } else {
            this.cancel()
          }
        }
      }).catch(e => {
        this.loading = false;
      });
    },
    // 组装表单数据提交
    getFormData (status = 1) {
      // 1保存 2提交
      this.form.billState = status
      this.form.projectCode = this.projectNumber
      this.form.projectNode = this.form.bsProjectNode ? this.form.bsProjectNode.id : ''
      return this.form;
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  .box-card {
    background-color: #fff;
    padding: 20px 30px 20px 30px;
    border-radius: 10px;

    .content-title {
      height: 40px;
      background-color: #e7eff6;
      padding-left: 20px;
      overflow: hidden;

      .title-icon {
        display: inline-block;
        margin-top: 8px;
        width: 6px;
        height: 24px;
        background-color: #1369a8;
        margin-right: 14px;
      }

      .title-details {
        overflow: hidden;
        line-height: 20px;
        display: inline-block;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        font-family: SourceHanSansSC-regular;
      }
    }

    .button {
      padding-top: 20px;
      text-align: right;

      .btn-submit {
        width: 80px;
        height: 38px;
        background: #1369a8;
        color: white;
      }

      .btn-cancel {
        width: 80px;
        height: 38px;
        background: #fff;
      }
    }
  }
}
</style>
